import React, { memo, useState } from 'react';
import classes from './partial-annotation.module.scss';
import { Button, Container, Popover, Theme, Typography, createStyles, makeStyles } from '@material-ui/core';

interface Props {
	headerMessage: string;
	footerMessage: string;
	targetMessage: string;
	popoverMessage: string;
	isBreakBeforeTargetText?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		popover: {
			pointerEvents: 'none',
		},
		paper: {
			padding: theme.spacing(1),
		},
	}),
);

export const PartialdAnnotation = memo((props: Props) => {
	const { headerMessage, footerMessage, targetMessage, popoverMessage, isBreakBeforeTargetText = false } = props;
	const styles = useStyles();
	const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
	// Popover管理
	const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
		setAnchorEl(event.currentTarget);
	};

	const handlePopoverClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? 'popover-text' : undefined;
	return (
		<>
			<Typography>
				{headerMessage}
				{isBreakBeforeTargetText ? (
					<>
						<br />
						{'　'}
					</>
				) : (
					''
				)}
				<span
					className={classes.popoverMessage}
					aria-owns={open ? 'mouse-over-popover' : undefined}
					aria-haspopup="true"
					onMouseEnter={handlePopoverOpen}
					onMouseLeave={handlePopoverClose}
				>
					{targetMessage}
				</span>
				{footerMessage}
				<Popover
					id={id}
					open={open}
					className={styles.popover}
					classes={{
						paper: styles.paper,
					}}
					anchorEl={anchorEl}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					onClose={handlePopoverClose}
					disableRestoreFocus
				>
					<Typography style={{ padding: '10px' }}>
						{popoverMessage.split('\n').map((lineMessage: string) => {
							return (
								<>
									{lineMessage}
									<br />
								</>
							);
						})}
					</Typography>
				</Popover>
			</Typography>
		</>
	);
});
